import {computed, effect, Injectable, signal} from '@angular/core';
import { AResourceService } from './a-resource.service';
import { LanguageModel } from '../../models/resources/language.model';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root',
})
export class LanguageService extends AResourceService<LanguageModel> {
  activeLanguage = signal<LanguageModel | null>(null);
  notActiveLanguages = computed(() => this.models().filter(l => l.code != this.activeLanguage()?.code))

  constructor(private translateService: TranslateService) {
    super('/languages', false);
    if(sessionStorage.getItem('languages'))
      this.apiResponse.set({data: JSON.parse(sessionStorage.getItem('languages')!)});

    effect(() => {
      if(!this.models())
        return

      let defaultLanguage = this.models().find(l => l.default) ?? this.models()[0]
      if(!this.activeLanguage())
        this.activeLanguage.set(JSON.parse(sessionStorage.getItem("language") ?? "null") ?? defaultLanguage)
    })

    effect(() => {
      if(!this.activeLanguage())
        return

      this.translateService.use(this.activeLanguage()!.code.toLowerCase()).subscribe()
      sessionStorage.setItem("language", JSON.stringify(this.activeLanguage()));
    })

    effect(() => {
      if(this.models())
        sessionStorage.setItem("languages", JSON.stringify(this.models()));
    });
  }
}

